(() => {
  const init = () => {
    const sheet = document.querySelector('menu-drawer[data-lp-inline]');
    if (!sheet || sheet.dataset.lpBound) return;
    sheet.dataset.lpBound = 'true';
    const root = sheet.querySelector('details');
    const trigger = root.querySelector('summary');
    sheet.addEventListener('click', event => {
      const close = event.target.closest('[data-lp-sheet-close]');
      if (close) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!close.disabled) sheet.closeMenuDrawer(event, trigger);
        return;
      }
      const summary = event.target.closest('.lp-inline-filter > summary');
      if (!summary) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = summary.parentElement;
      details.open = !details.open;
      summary.setAttribute('aria-expanded', String(details.open));
    }, true);
    sheet.addEventListener('keyup', event => {
      if (event.key !== 'Escape' || !root.open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      sheet.closeMenuDrawer(event, trigger);
    }, true);
    root.addEventListener('toggle', () => {
      if (!root.open) return;
      root.querySelectorAll('[data-lp-default-open]').forEach(details => {
        details.open = true;
        details.querySelector('summary').setAttribute('aria-expanded', 'true');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
